/** Resolve nested module pages without matching /agents-other or root /. */
export function findParentModuleRoute<T extends { path: string }>(
  pathname: string,
  routes: T[]
): T | undefined {
  return routes
    .filter(
      ({ path }) =>
        path !== "/" &&
        !path.includes(":") &&
        !path.includes("*") &&
        (pathname === path.replace(/\/$/, "") || pathname.startsWith(`${path.replace(/\/$/, "")}/`))
    )
    .sort((a, b) => b.path.length - a.path.length)[0]
}
